module.exports = __webpack_public_path__ + "static/media/183.342574d5.wav";